import { gql } from '@apollo/client';

export const HostedTicketEventFields = gql`
  fragment HostedTicketEventFields on TicketEventView {
    id
    slug
    name
    status
    version
    ticketsEnabled
    coverImageUrl
    startsAt
    timezone
    venueName
    maxAdmissions
    ticketPriceFrom
    publishedAt
    stream {
      id
      name
      slug
      imageURL
      price
      requestedPrice
      isFree
      streamStatus
      store {
        id
        slug
      }
    }
  }
`;

/** What checkout needs of an event, and whether it is selling. */
export const TicketCheckoutEventFields = gql`
  fragment TicketCheckoutEventFields on TicketEventView {
    id
    name
    status
    ticketsEnabled
    coverImageUrl
    startsAt
    timezone
    salesCloseAt
    venueName
    venueAddress {
      city
    }
    stream {
      id
    }
  }
`;

/** What a fan sees of an event: its card, page and checkout header. */
export const PublicTicketEventFields = gql`
  fragment PublicTicketEventFields on TicketEventView {
    ...TicketCheckoutEventFields
    slug
    description
    endsAt
    venueAddress {
      addressLine1
      addressLine2
      city
      region
      postalCode
      country
    }
    ticketPriceFrom
    hashtags {
      id
      name
    }
    host {
      id
      slug
      firstName
      lastName
      storeDetails {
        id
        storeName
        avatarURL
      }
    }
    stream {
      id
      slug
      price
      isFree
      store {
        id
        slug
      }
    }
  }
  ${TicketCheckoutEventFields}
`;

export const TicketHoldFields = gql`
  fragment TicketHoldFields on TicketHoldView {
    id
    expiresAt
    subtotal
    discountAmount
    serviceFeeAmount
    promocode
    expectedTotal
    currency
    lines {
      tierId
      quantity
      lineTotal
    }
  }
`;

export const TicketOrderFields = gql`
  fragment TicketOrderFields on TicketOrderView {
    id
    status
  }
`;

/** What a fan's orders, tickets and passes show of the event. */
export const MyTicketEventFields = gql`
  fragment MyTicketEventFields on TicketEventView {
    id
    slug
    name
    coverImageUrl
    startsAt
    timezone
    venueName
  }
`;

export const MyTicketOrderFields = gql`
  fragment MyTicketOrderFields on TicketOrderView {
    id
    reference
    status
    createdAt
    currency
    subtotal
    discountAmount
    serviceFeeAmount
    total
    ticketEvent {
      ...MyTicketEventFields
    }
  }
  ${MyTicketEventFields}
`;

export const MyTicketFields = gql`
  fragment MyTicketFields on TicketView {
    id
    serial
    status
    tierLabel
    ticketOrderId
    canTransfer
    pendingTransfer {
      id
      recipientEmail
    }
    ticketEvent {
      ...MyTicketEventFields
    }
  }
  ${MyTicketEventFields}
`;
